module.exports = __webpack_public_path__ + "img/11.0eb73a46.png";